import { z } from 'zod'

const ZTextContent = z.object({
  text: z.string(),
})

export default ZTextContent
